import React from 'react'
import { Text, CheckboxFieldReduxFormWrapper } from '@adc/ui-core'
import { Field } from 'redux-form'
import { MAX_COBUYERS } from '../constants'

const MoreBuyersLabel = () => (
  <label>
    <Text color='gray'>
      Check if you have more than {MAX_COBUYERS} Co-Buyers. One of our
      representatives will contact you.
    </Text>
  </label>
)

const MoreBuyersCheckbox = () => (
  <div className='u-pl-2 u-pr-2 u-mt-2'>
    <Field
      name='moreBuyersInvolved'
      component={CheckboxFieldReduxFormWrapper}
      checkboxLabel={<MoreBuyersLabel />}
      elmId='more_buyers_involved'
    />
  </div>
)

export default MoreBuyersCheckbox
